import { ReactNode } from 'react';
import InputsProviderWrapper from 'screens/InputsMarket/providers/InputsProviderWrapper';
import { BuyersMarketCartProvider } from 'hooks/useBuyersMarketCart';
import { MarketDatesProvider } from './MarketDatesProvider';

// The market-wide data providers, kept apart from the navigation chrome so that they stay
// mounted across a switch to the print layout: printing swaps the chrome away, and a screen
// rendered without it still consumes cart, dates and inputs context.
const MarketProviders = ({ children }: { children: ReactNode }) => {
  return (
    <MarketDatesProvider>
      <BuyersMarketCartProvider>
        <InputsProviderWrapper>{children}</InputsProviderWrapper>
      </BuyersMarketCartProvider>
    </MarketDatesProvider>
  );
};

export default MarketProviders;
